import AppRouter from '@/navigation/Router';
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { NotificationProvider } from './contexts/NotificationContext.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { RoomProvider } from './contexts/RoomContext.jsx';
import './styles/index.css';

export default function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <AuthProvider>
          <RoomProvider>
            <div className="min-h-screen">
              <a
                href="#main"
                className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-white text-black p-2 rounded z-50"
              >
                Aller au contenu
              </a>
              <main id="main">
                <AppRouter />
              </main>
            </div>
          </RoomProvider>
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}
